<template>
  <v-list-item class="d-flex align-center">
    <!-- Main content (title, version, and content) -->

    <v-list-item-title>
      <v-tooltip bottom>
        <template #activator="{ props }">
          <span class="text-h6" v-bind="props">
            {{ versionStore.appVersion.title }}
          </span>
        </template>
        <span>{{ versionStore.appVersion.name }}</span>
      </v-tooltip>
    </v-list-item-title>
    <v-list-item-subtitle>
      <!-- Highlight the content if there's an error -->
      <span>
        {{ versionStore.appVersion.version }} -
        {{ versionStore.appVersion.releaseSignature }}
        <!-- Only show the environment in parentheses if there's no error -->
        <span> ({{ versionStore.appVersion.environment }}) </span>
      </span>

      <!-- Tooltip and release date, hidden if error -->
      <v-tooltip bottom>
        <template #activator="{ props }">
          <span v-bind="props"> Released: {{ AppReleasedOn }} </span>
        </template>
        <span>{{ versionStore.appVersion.lastUpdated }}</span>
      </v-tooltip>
    </v-list-item-subtitle>

    <template #append>
      <span style="width: 48px"></span>
    </template>
  </v-list-item>
</template>

<script setup lang="ts">
  import { useVersionStore } from '@/store/versionStore';
  import { computed } from 'vue';
  import { useTimeAgo } from '@vueuse/core';

  const versionStore = useVersionStore();

  const AppReleasedOn = computed(() => {
    if (versionStore.appVersion.lastUpdated) {
      return useTimeAgo(new Date(versionStore.appVersion.lastUpdated)).value;
    }
    return '';
  });
</script>

<style scoped>
  .text-error {
    color: red;
  }
</style>
